import { Grid } from '@mui/material';
import Table from '@mui/material/Table';
import TableBody from '@mui/material/TableBody';
import TableCell from '@mui/material/TableCell';
import TableContainer from '@mui/material/TableContainer';
import TableHead from '@mui/material/TableHead';
import TableRow from '@mui/material/TableRow';
import * as React from 'react';
import { useState } from 'react';
import { useDispatch } from 'react-redux';
import { archLevel } from 'src/data/config';
import { hideLoader, showLoader } from 'src/store/Loader';
import { useAppSelector } from 'src/store/hooks';
import './MilestoneTracking.scss';
import { useAssociateDocuments } from './useAssociateDocuments';

const AssociatedDocuments: React.FunctionComponent<any> = ({ selectedMilestone }) => {
  const dispatch = useDispatch();
  const [gridRows, setGridRows] = useState<any>([]);
  const studyId: any = useAppSelector(state => state.site.selectedStudy);
  const selectedCountry = useAppSelector(state => state.site.selectedCountry);
  const selectedSite = useAppSelector(state => state.site.selectedSite);
  const { getAllDocsByMilestoneNameSitelevel, getAllDocsByMilestoneNameSitelevelISF } = useAssociateDocuments();
  const getDocs = async () => {
    dispatch(showLoader());

    if (archLevel === 'sponsor') {
      let associatedDocs = [];
      const res = await getAllDocsByMilestoneNameSitelevel({
        site_id: selectedSite,
        study_id: studyId,
        country: selectedCountry,
        application: process.env.REACT_APP_NAME,
        milestone: selectedMilestone?.minor_milestone,
        user_based_details: false,
        originally_uploaded: false,
        module_section_related: 'MILESTONE TRACKING',
        parent_entity_related: ''
      });
      if (res?.data && res?.data?.selected_data.length > 0) {
        associatedDocs = res?.data.selected_data.map((doc: any) => {
          return {
            artifact_name: doc.document_data?.tmf_artifact_name,
            document_name: doc.document_data?.tmf_document_name,
            version_number: doc.document_data?.tmf_doc_version_number.toFixed(1),
            status: doc.document_data?.tmf_doc_status
          };
        });
      }
      setGridRows([...gridRows, ...associatedDocs]);
    } else {
      let associatedDocsISF = [];
      const res2 = await getAllDocsByMilestoneNameSitelevelISF({
        site_id: selectedSite,
        study_id: studyId,
        country: selectedCountry,
        application: process.env.REACT_APP_NAME,
        milestone: selectedMilestone?.minor_milestone,
        user_based_details: false,
        originally_uploaded: false,
        module_section_related: 'MILESTONE TRACKING',
        parent_entity_related: ''
      });
      if (res2.data && res2.data.selected_data.length > 0) {
        associatedDocsISF = res2?.data?.selected_data.map((doc: any) => {
          return {
            artifact_name: doc.document_data?.isf_artifact_name,
            document_name: doc.document_data?.isf_document_name,
            version_number: doc.document_data?.isf_doc_version_number.toFixed(1),
            status: doc.document_data?.isf_doc_status
          };
        });
      }
      setGridRows([...gridRows, ...associatedDocsISF]);
    }

    dispatch(hideLoader());
  };
  React.useEffect(() => {
    getDocs();
  }, []);
  return (
    <div className="associated-docs-page">
      <Grid container className="associated-docs-list">
        <Grid item md={12}>
          <TableContainer className="associated-docs-table">
            <Table stickyHeader aria-label="Associated Documents">
              <TableHead>
                <TableRow>
                  <TableCell>
                    <b>Artifact Name</b>
                  </TableCell>
                  <TableCell>
                    <b>Document Name</b>
                  </TableCell>
                  <TableCell>
                    <b>Version number</b>
                  </TableCell>
                  <TableCell>
                    <b>Status</b>
                  </TableCell>
                </TableRow>
              </TableHead>
              <TableBody>
                {gridRows.length ? (
                  gridRows.map((row: any, index: number) => (
                    <TableRow key={index}>
                      <TableCell>{row.artifact_name}</TableCell>
                      <TableCell>{row.document_name}</TableCell>
                      <TableCell>{row.version_number}</TableCell>
                      <TableCell>{row.status}</TableCell>
                    </TableRow>
                  ))
                ) : (
                  <TableRow key={1}>
                    <TableCell align='center' colSpan={4} sx={{ color: 'rgba(0,0,0,0.6)'}}>No associated documents found for selected milestone</TableCell>
                  </TableRow>
                )}
              </TableBody>
            </Table>
          </TableContainer>
        </Grid>
      </Grid>
    </div>
  );
};

export default AssociatedDocuments;
